<template>
  <div class="app-container">
    <div class="title"><span v-html="$t('message.cuotas.titulo' + tipoEmpresa)"></span></div>

    <Divider v-if="mostrarDocumentacion">
      <v-btn flat small class="ayuda" :to="'/cuotas/presentacion-cuota/ayuda' + tipoEmpresa"
        ><v-icon left color="primary">info</v-icon>{{ $t('message.cuotas.instrucciones') }}
      </v-btn>
    </Divider>

    <v-form ref="formDeclaracion" lazy-validation>
      <Divider>{{ $t('message.cuotas.gas.apartados1') }}</Divider>
      <v-container fluid grid-list-xs>
        <v-layout d-inline-flex>
          <v-flex xs6>
            <v-text-field
              :label="$t('message.comun.mesDeclaracion')"
              v-model="periodoDeclaracionText"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <MonthPicker
              id="mesFacturacion"
              v-model="form.mesFacturacion"
              placeholder="mes-año"
              :pickerOptions="allowedMonths"
              :label="$t('message.comun.mesFacturacion')"
            ></MonthPicker>
          </v-flex>
        </v-layout>
      </v-container>

      <Divider>{{ $t('message.cuotas.gas.apartados2') }}</Divider>

      <PeriodosGasCuotas
        id="tblfacturacionTarifas"
        :data="cuotasGas"
        :mesFacturacion="form.mesFacturacion"
        :baseCotizacion="baseCotizacionGas"
        @modify="modificarPeriodoHandler"
        @remove="removePeriodoHandler"
      ></PeriodosGasCuotas>

      <Divider>{{ $t('message.cuotas.gas.apartados3') }}</Divider>
      <PeriodosGasCuotas
        id="tblfacturacionPeajes"
        :data="cuotasPeajes"
        :mesFacturacion="form.mesFacturacion"
        :baseCotizacion="baseCotizacionPeaje"
        @modify="modificarPeriodoHandler"
        @remove="removePeriodoHandler"
      ></PeriodosGasCuotas>

      <!-- Declarante e ingreso -->
      <DeclaranteIngreso
        v-if="form.mesFacturacion"
        :nif="userNIFCIF"
        :declarante="userName"
        :resumen="form.resumenes[0]"
      ></DeclaranteIngreso>

      <v-layout>
        <v-flex text-xs-center>
          <Boton
            id="btnPresentar"
            :onclick="onSubmitAviso"
            v-if="form.mesFacturacion"
            :deshabilitado="puedePresentar"
            >{{ $t('message.cuotas.presentarCuota') }}</Boton
          >
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Ventana modal de alerta -->
    <Modal
      id="modalAvisoCuotaElect"
      :modalShow="showAlert"
      size="400"
      :title="$t('message.cuotas.presentarCuota')"
    >
      <p class="negrita text-xs-center">{{ $t('message.tasas.presentarTasaAviso') }}</p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="showAlert = false">
          Cancelar
        </v-btn>
        <v-btn color="primary" @click="onSubmit">
          Enviar
        </v-btn>
      </v-card-actions>
    </Modal>
  </div>
</template>
<script>
// General
import { mapActions, mapGetters } from 'vuex';
import redirect from '@/router/redirect';
// Componentes
import { Divider, Boton, MonthPicker, Modal } from '@/components';
import { PeriodosGasCuotas, DeclaranteIngreso } from './components';
// Apis
import { getVigenciaCuotaEmpresa, getImpuestoCuota } from '@/api/empresas';
import { newDeclaracion } from '@/api/declaraciones';
// Utils
import { empConst, RESUMEN_CUOTA_INIT } from '@/utils/constants';
import { notificarError } from '@/utils/notification';
import { ID_CUOTA_GAS, BASECOTIZACION_CUOTAS, TIPO_DECLARACION_CUOTA } from './cuotasConst';
import moment from 'moment';
export default {
  name: 'cuotaGas',
  data() {
    return {
      form: {
        idEmpresa: null,
        tipoDeclaracion: TIPO_DECLARACION_CUOTA,
        mesDeclaracion: null,
        mesFacturacion: null,
        cuotasDeclaracion: [],
        resumenes: []
      },
      showAlert: false,
      pickerOptions: {
        disabledDates: {
          from: moment()
            .startOf()
            .date(0)
            .toDate()
        }
      }
    };
  },
  components: {
    Divider,
    Boton,
    Modal,
    MonthPicker,
    PeriodosGasCuotas,
    DeclaranteIngreso
  },
  created() {
    this.setBreadcrumb({
      breadcrumb: [
        { text: 'Inicio', to: '/', disabled: false },
        { text: 'Cuotas', to: '/cuotas', disabled: false },
        { text: 'Presentar Cuota Gas', to: '/cuotas/presentacion-Gas', disabled: true }
      ],
      menuSelected: '/cuotas/presentacion-Gas'
    });
    // Se verifica que pueda acceder y se cargan datos iniciales
    this.cargarInfo();
  },
  watch: {
    'form.cuotasDeclaracion': {
      handler: function() {
        this.actualizarResumen();
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters(['empresaSelected', 'userNIFCIF', 'userName']),
    tipoEmpresa() {
      return this.empresaSelected.cdtipemp;
    },
    mostrarDocumentacion() {
      return empConst.TIPO_ELE === this.empresaSelected.cdtipemp;
    },
    periodoDeclaracionText() {
      return this.form.cuotasDeclaracion
        ? moment(this.form.mesDeclaracion).format('MMMM [de] YYYY')
        : '';
    },
    cuotasGas() {
      return this.form.cuotasDeclaracion.filter(
        item => item.idBaseCo === BASECOTIZACION_CUOTAS.GAS
      );
    },
    cuotasPeajes() {
      return this.form.cuotasDeclaracion.filter(
        item => item.idBaseCo === BASECOTIZACION_CUOTAS.PEAJES
      );
    },
    baseCotizacionGas() {
      return BASECOTIZACION_CUOTAS.GAS;
    },
    baseCotizacionPeaje() {
      return BASECOTIZACION_CUOTAS.PEAJES;
    },
    puedePresentar() {
      // El importe a ingresar debe ser mayor que 0.
      return this.form.resumenes[0].totalIngresar === 0;
    }
  },
  methods: {
    ...mapActions(['setLoading', 'setBreadcrumb']),
    allowedMonths(val) {
      return (
        moment(val).toDate() <=
        moment()
          .startOf()
          .date(0)
          .toDate()
      );
    },
    cargarInfo() {
      if (this.tipoEmpresa !== empConst.TIPO_GAS && this.tipoEmpresa !== empConst.TIPO_ELE) {
        redirect.toError(this.$t('message.errores.tipoNoPermitido'));
      }
      this.setLoading(true);
      // Preparamos el payload
      let payload = {
        idEmpresa: this.empresaSelected.idempres,
        idCuota: ID_CUOTA_GAS
      };
      let vigenciaPromise = getVigenciaCuotaEmpresa(payload);
      let impuestoPromise = getImpuestoCuota(payload);
      let self = this;
      Promise.all([vigenciaPromise, impuestoPromise]).then(
        results => {
          // Cargamos datos inciales
          self.form.idEmpresa = this.empresaSelected.idempres;
          self.form.mesDeclaracion = moment()
            .startOf('month')
            .toDate();

          // Resumen total
          let resumen = {};
          Object.assign(resumen, RESUMEN_CUOTA_INIT);
          resumen.id = ID_CUOTA_GAS;
          resumen.iva = results[1].data;
          resumen.numCuenta = this.$options.filters
            .datosBancariosIban(resumen.id)
            .replace(/ /g, '');
          self.form.resumenes.push(resumen);
          self.setLoading(false);
        },
        error => {
          if (error.response && error.response.status === 404) {
            redirect.toError(new Error(this.$t('message.errores.tasaNoPermitida')));
          } else {
            redirect.toError(error);
          }
          this.setLoading(false);
        }
      );
    },
    modificarPeriodoHandler(payload) {
      var index = this.form.cuotasDeclaracion.findIndex(function(item) {
        return item.idBaseCo === payload.idBaseCo && item.id === payload.id;
      });
      if (index == -1) {
        // Añadirmos a la lista
        this.form.cuotasDeclaracion.push(payload);
      } else {
        //modificamos
        Object.assign(this.form.cuotasDeclaracion[index], payload);
      }
    },
    removePeriodoHandler(payload) {
      var index = this.form.cuotasDeclaracion.findIndex(function(item) {
        return item.idBaseCo === payload.idBaseCo && item.id === payload.id;
      });
      // Borramos
      this.form.cuotasDeclaracion.splice(index, 1);
    },
    actualizarResumen() {
      this.form.resumenes[0].total = this.form.cuotasDeclaracion.reduce((total, item) => {
        return total + item.cuotaTributaria;
      }, 0);
      this.form.resumenes[0].total = Math.round10(this.form.resumenes[0].total, -2);
      let tipo = this.form.resumenes[0].iva || 0;
      this.form.resumenes[0].importeIva = Math.round10(
        (this.form.resumenes[0].total * tipo) / 100,
        -2
      );
      this.form.resumenes[0].totalIngresar = Math.round10(
        this.form.resumenes[0].total + this.form.resumenes[0].importeIva,
        -2
      );
    },
    onSubmitAviso() {
      this.showAlert = true;
    },
    onSubmit() {
      // Para poder presentar la cantidad a ingresar debe ser disinta de 0. method puedepresentar()
      this.setLoading(true);
      this.showAlert = false;
      newDeclaracion(JSON.stringify(this.form))
        .then(response => {
          this.$router.push({
            name: 'justificante',
            params: { cdregist: response.data.cdregist, nujustas: response.data.nujustas }
          });
        })
        .catch(error => {
          notificarError(this, error);
        })
        .then(() => {
          this.setLoading(false);
        });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/resources/styles/variables.scss';
.title {
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  min-height: 30px;
}

.v-form > .container > .layout > .flex {
  padding: 8px;
}
</style>
